export enum RecordInfo {
  ENTER_SEARCH_CRITERIA = "Enter search criteria to view records.",
  NO_ASSOCIATED_DOMAIN_WARNING = "There is no domain associated with this record.",
  NO_ASSOCIATED_DOMAIN = "No Associated Domain",
}

export enum RecordRequestRoutes {
  RECORDS_LIST = "/api/ajax/records",
}
